// url.js
import { BASE_URL } from './root_url';
export const MOBILE_URL = `${BASE_URL}/v1/mobile`;

// auth
export const CHECK_TAKEN = `${BASE_URL}/v1/baseuser/checktaken/`;
export const FORGET_USERNAME_URL = `${BASE_URL}/v1/mobile/account/forgot-username/`;
export const FORGET_PASSWORD_URL = `${BASE_URL}/v1/mobile/account/forgot-password/`;
export const LOGIN_URL = `${BASE_URL}/api-token-auth/`;
export const RESET_PASSWORD_URL = `${MOBILE_URL}/account/change-password/`;
export const RESET_EMAIL_URL = `${MOBILE_URL}/account/req-reset-password/`;
export const RESET_PASSWORD = `${MOBILE_URL}/account/reset-password/`;
// export const SIGNUP_URL = `${BASE_URL}/v1/baseuser/register/customer/`;
export const SIGNUP_URL = `${BASE_URL}/v1/baseuser/register/customer_mlm/`;
export const SEND_VERIFICATION_CODE = `${MOBILE_URL}/account/verify-active/`;
export const CHANGE_PASSWORD = `${MOBILE_URL}/account/change-password/`;
export const UPLOAD_TAX_FILE = `${MOBILE_URL}/upload_taxfile`;

// profile
export const ADDRESS_URL = `${MOBILE_URL}/address`;
export const CUSTOMER_INFORMATION_URL = `${BASE_URL}/v1/customer/oao/`;
export const DEFAULT_ADDRESS_URL = `${MOBILE_URL}/address/default`;
export const USER_CONFIG_URL = `${MOBILE_URL}/user_config`;
export const VERIFY_EMAIL_URL = `${MOBILE_URL}/account/verify_email_req`;
export const UPDATE_USER_PHOTO = `${MOBILE_URL}/account/upload_profile`;

// product
export const BILLBOARD_URL = `${MOBILE_URL}/billboard/`;
export const CATEGORY_URL = `${MOBILE_URL}/category/`;
export const CATEGORY_2_URL = `${MOBILE_URL}/category2/`;
export const PRODUCTS_URL = `${MOBILE_URL}/product/`;
export const SEARCH_PRODUCT_URL = `${MOBILE_URL}/product/?Name=`;
export const HOME_GROUP_URL = `${MOBILE_URL}/group_with_products/`;
export const PRODUCTS_GROUP = `${MOBILE_URL}/group`;
export const PRODUCTS_CATEGORY = `${MOBILE_URL}/category`;
export const PRODUCTS_GROUP_DISPLAY = `${MOBILE_URL}/group_display`;
export const PRODUCTS_CATEGORY_DISPLAY = `${MOBILE_URL}/category_display`;
export const GROUP_BUY_URL = `${MOBILE_URL}/groupon`;
export const WHOLESALE_FETCH_URL = `${MOBILE_URL}/wholesale`;

// checkout
export const ANYWHERE_COMMERCE_URL = `${BASE_URL}/v1/acpayment/store_card/`;
export const CHECKOUT_URL = `${MOBILE_URL}/order/`;
export const CHECKOUT_TOUR_URL = `${MOBILE_URL}/consolidated-checkout/`;
export const VALIDATE_DELIVERY_RADIUS_URL = `${MOBILE_URL}/check_address_location`;
export const VALIDATE_PROMO_CODE_URL = `${MOBILE_URL}/promocode`;
export const ZIPCODE_URL = `${BASE_URL}/v1/purchase/taxarea/`
export const ZIPCODE_URL_NO_LOGIN = `${BASE_URL}/v1/purchase/taxareanotlogin/`

// order
export const CONSOLIDATED_ORDERS_URL = `${MOBILE_URL}/consolidated-orders`;
export const DISPATCH_PORTAL_URL = `${BASE_URL}/v1/sale/sales_mobile_order/external`;
export const MOBILE_SALES_ORDERS_URL = `${BASE_URL}/v1/sale/sales_mobile_order/search/`;
export const ORDER_URL = `${MOBILE_URL}/order/`;
export const PENDING_ORDERS_URL = `${MOBILE_URL}/pending-orders`;
export const SALES_ORDER_URL = `${MOBILE_URL}/sales_order/`;
export const SALES_INVOICE_URL = `${MOBILE_URL}/sales_invoice/`;

// contact
export const CONTACT_URL = `${BASE_URL}/v1/contact/info/`;

// cart
export const CART_URL = `${BASE_URL}/v1/mobile/cart`

// become a driver
export const DRIVERAPPLY = `${BASE_URL}/v1/baseuser/mmdriver-application`

// MLM
export const MULTILEVEL_MARKETING_URL = `${MOBILE_URL}/mlm`;

// MLM WITHDRAW
export const MULTILEVEL_MARKETING_WITHDRAW_URL = `${MOBILE_URL}/mlm/withdraw`;

// Invite history
export const INVITE_HISTORY_URL = `${MOBILE_URL}/mlm/monthly_invite_history`;

// shipstation
export const SHIPSTATION_API = `${BASE_URL}/v1/sale/shipping/rate_lookup/`;



// WEBPACK FOOTER //
// ./src/api/url.js